import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { DecodedToken } from './useIsAdmin';
import { temPapel } from '../shared/papeis';

/** Retorna o userType do token (ou null se não autenticado/token inválido). */
export default function useUserType(): string | null {
  const token = useSelector((state: any) => state.auth.accessToken);

  if (!token) return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded.userType ?? null;
  } catch {
    return null;
  }
}

/**
 * TI: perfil de suporte técnico — vê todas as telas da Oficina, sem ações operacionais (at-25).
 *
 * at-81: pergunta se o usuário TEM o papel TI, não se ele É só TI. Quem acumula TI com um papel
 * operacional continua tendo as ações escondidas pela tela; a permissão real segue sendo decidida
 * pelo backend, que avalia a união e libera pelo outro papel.
 */
export function useIsTi(): boolean {
  const token = useSelector((state: any) => state.auth.accessToken);

  if (!token) return false;

  try {
    return temPapel(jwtDecode<DecodedToken>(token), 'TI');
  } catch {
    return false;
  }
}
